import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AppProvider, useApp } from './AppContext'
import Layout from './components/Layout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Contacts from './pages/Contacts'
import Documents from './pages/Documents'
import Produits from './pages/Produits'
import Parametres from './pages/Parametres'
import Alertes from './pages/Alertes'
import Equipe from './pages/Equipe'
import Rapports from './pages/Rapports'
import Credentials from './pages/Credentials'
import Stock from './pages/Stock'
import Comptabilite from './pages/Comptabilite'

function RequireAuth({ children }) {
  const { user, loading } = useApp()
  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: 'var(--text3)' }}>Chargement...</div>
  if (!user) return <Navigate to="/login" replace />
  return children
}
function RequireAdmin({ children }) {
  const { user, isAdmin, loading } = useApp()
  if (loading) return null
  if (!isAdmin) return <Navigate to="/" replace />
  return children
}

function AppRoutes() {
  const { user, loading } = useApp()
  if (loading) return null

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
        <Route path="/" element={<RequireAuth><Layout /></RequireAuth>}>
          <Route index element={<Dashboard />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="documents" element={<Documents />} />
          <Route path="produits" element={<Produits />} />
          <Route path="alertes" element={<Alertes />} />
          <Route path="parametres" element={<Parametres />} />
          <Route path="equipe" element={<RequireAdmin><Equipe /></RequireAdmin>} />
          <Route path="rapports" element={<Rapports />} />
          <Route path="credentials" element={<Credentials />} />
          <Route path="stock" element={<Stock />} />
          <Route path="comptabilite" element={<Comptabilite />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default function App() {
  return (
    <AppProvider>
      <AppRoutes />
    </AppProvider>
  )
}
